import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TimelineBlock, TimelineKind } from '@/cloud/models/assistant.models';
import { parseUtc } from '@/cloud/models/device-status';

const ICONS: Record<TimelineKind, string> = {
    info: 'pi pi-circle-fill',
    warning: 'pi pi-exclamation-triangle',
    error: 'pi pi-times-circle',
    success: 'pi pi-check-circle',
    action: 'pi pi-bolt'
};

/** An incident told as a vertical timeline, oldest first. */
@Component({
    selector: 'app-assistant-timeline',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (block().title) {
            <div class="ab-title">{{ block().title }}</div>
        }
        <ol class="timeline">
            @for (e of block().events; track $index) {
                <li [attr.data-kind]="e.kind">
                    <span class="tl-dot"><i [class]="icon(e.kind)" aria-hidden="true"></i></span>
                    <span class="tl-body">
                        <span class="tl-label">{{ e.label }}</span>
                        @if (e.timeUtc) {
                            <time class="muted" [attr.datetime]="e.timeUtc">{{ time(e.timeUtc) }}</time>
                        }
                    </span>
                </li>
            }
        </ol>
    `,
    styleUrl: './blocks.scss'
})
export class AssistantTimelineComponent {
    readonly block = input.required<TimelineBlock>();

    icon(kind: TimelineKind): string {
        return ICONS[kind] ?? ICONS.info;
    }

    time(value: string): string {
        const t = parseUtc(value);
        return t === null ? value : new Date(t).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
}
